"use strict"
import axios from "axios";

const getDefaultState = () => { return {} };

const state = getDefaultState();

const getters = {
  getResponseById: (state, getters, rootState) => id => {
    return rootState.responses.responses.find(x => x.id === id);
  }
};

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultState());
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
